export default __webpack_public_path__ + "static/media/101.1c7b0472.png";